define('rest/trafficIncidents',["http", "security", "./utils"], function (http, security, utils) {
    "use strict";

    var queryParamNames = ["language", "expandCluster", "geometries", "originalPosition"];

    return {
        incidentsDetails: function (options, callback) {
            var pathParams = {};
            var queryParams = {};

            // default the trafficModelID to -1
            pathParams.trafficModelID = utils.or(options.trafficModelID, -1);

            pathParams.zoom = utils.required(options.zoomLevel, "Missing zoomLevel required parameter");

            pathParams.minLon = utils.required(options.minLon, "Missing minLon required parameter");
            pathParams.minLat = utils.required(options.minLat, "Missing minLat required parameter");
            pathParams.maxLon = utils.required(options.maxLon, "Missing maxLon required parameter");
            pathParams.maxLat = utils.required(options.maxLat, "Missing maxLat required parameter");

            pathParams.style = utils.or(options.style, "night");

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey("services/traffic"));

            utils.extractQueryParams(options, queryParams, queryParamNames);

            var baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/");
            var serviceUrl = utils.or(options.serviceUrl, "traffic/services/4/incidentDetails/{style}/{minLat},{minLon},{maxLat},{maxLon}/{zoom}/{trafficModelID}/{contentType}?projection=EPSG4326");

            http.get({
                url: baseUrl + serviceUrl,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                fail: options.fail
            });
        }
    };
});

